import React from "react";
import WarningCircle from "../../assets/icons/warning-circle-white.svg";

//No longer used in Omnidox

export const ValidationErrors = ({ touched, message }) => {
  if (touched && message) {
    return (
      <div className="form-message invalid">
        <div className="icon-wrapper">
          <img src={WarningCircle} alt="Validation Error" />
        </div>
        <div className="warning-text">{message}</div>
      </div>
    );
  }
  return null;
};

export default ValidationErrors;
